module.exports = __webpack_public_path__ + "static/media/order_info.1831a638.svg";